import React from "react";
import { Helmet } from "react-helmet";

const Head = ({ ...props }) => {
  return (
    <Helmet>
      <title>{props.title ? props.title + " | " : null} {process.env.REACT_APP_HEAD}</title>
    </Helmet>
  );
};
export default Head;
